module.exports = "../../app/cells/components/common_questions_cell.rb";